var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('b-row',{staticClass:"m-3"},[_c('h1',[_vm._v("myTamatNotif")])]),_c('router-view',{attrs:{"to":"/"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }